// extracted by mini-css-extract-plugin
export default {"rowBlock":"B5yln___antdOverrides-module__rowBlock"};